/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: organization_team.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  CreateOrganizationTeamRequest,
  CreateOrganizationTeamResponse,
  DeleteOrganizationTeamRequest,
  DeleteOrganizationTeamResponse,
  GetOrganizationTeamRequest,
  GetOrganizationTeamResponse,
  ListOrganizationTeamsRequest,
  ListOrganizationTeamsResponse,
  UpdateOrganizationTeamRequest,
  UpdateOrganizationTeamResponse,
} from '../types/organization_team';

export const createOrganizationTeamService = (transport: Transport) => ({
  async createOrganizationTeam(
    request: CreateOrganizationTeamRequest,
    options: RequestOptions = {},
  ): Promise<CreateOrganizationTeamResponse> {
    const { organization_id, ...body } = request;
    const url = getApiPath(API_METHODS.OrganizationTeamService.CreateOrganizationTeam, {
      organization_id,
    });
    return transport.post<CreateOrganizationTeamResponse>(url, body, options);
  },

  async getOrganizationTeam(
    request: GetOrganizationTeamRequest,
    options: RequestOptions = {},
  ): Promise<GetOrganizationTeamResponse> {
    const { organization_id, team_id } = request;
    const url = getApiPath(API_METHODS.OrganizationTeamService.GetOrganizationTeam, {
      organization_id,
      team_id,
    });
    return transport.get<GetOrganizationTeamResponse>(url, options);
  },

  async listOrganizationTeams(
    request: ListOrganizationTeamsRequest,
    options: RequestOptions = {},
  ): Promise<ListOrganizationTeamsResponse> {
    const { organization_id, ...params } = request;
    const url = getApiPath(API_METHODS.OrganizationTeamService.ListOrganizationTeams, {
      organization_id,
    });
    return transport.get<ListOrganizationTeamsResponse>(url, { params, ...options });
  },

  async updateOrganizationTeam(
    request: UpdateOrganizationTeamRequest,
    options: RequestOptions = {},
  ): Promise<UpdateOrganizationTeamResponse> {
    const { organization_id, team_id, ...body } = request;
    const url = getApiPath(API_METHODS.OrganizationTeamService.UpdateOrganizationTeam, {
      organization_id,
      team_id,
    });
    return transport.post<UpdateOrganizationTeamResponse>(url, body, options);
  },

  async deleteOrganizationTeam(
    request: DeleteOrganizationTeamRequest,
    options: RequestOptions = {},
  ): Promise<DeleteOrganizationTeamResponse> {
    const { organization_id, team_id } = request;
    const url = getApiPath(API_METHODS.OrganizationTeamService.DeleteOrganizationTeam, {
      organization_id,
      team_id,
    });
    return transport.delete<DeleteOrganizationTeamResponse>(url, options);
  },
});

export type OrganizationTeamService = ReturnType<typeof createOrganizationTeamService>;
